import { keyframes } from '@mui/system';

import { StepIndicatorType } from './StepIndicator/StepIndicator';

export const getStepperWrapperStyles = (isMobile: boolean) => {
	return {
		display: 'flex',
		gap: isMobile ? '12px' : '18px',
	};
};

export const stepWrapperStyles = {
	flexGrow: 1,
	width: '100%',
	overflow: 'auto',
};

export const getStepTitleStyles = (stepIndicatorType: StepIndicatorType) => {
	const commonStyles = {
		cursor: 'pointer',
		fontFamily: 'objektiv-mk1,sans-serif',
		fontSize: '1.25rem',
		fontWeight: 700,
		lineHeight: '1.75rem',
	};

	if (stepIndicatorType === StepIndicatorType.COMPLETED || stepIndicatorType === StepIndicatorType.CURRENT) {
		return {
			...commonStyles,
			color: 'text.primary',
		};
	} else {
		return {
			...commonStyles,
			color: 'text.disabled',
		};
	}
};

export const getStepContentWrapperVisibilityStyles = (isMobile: boolean, isCurrentStep: boolean) => {
	if (isMobile) {
		if (isCurrentStep) {
			return {
				display: 'initial',
			};
		} else {
			return {
				display: 'none',
			};
		}
	}
};

export const getStepContentWrapperStyles = (stepIndicatorType: StepIndicatorType) => {
	const commonStyles = {
		padding: '0 0 20px 0',
	};

	if (stepIndicatorType === StepIndicatorType.UPCOMING) {
		return {
			...commonStyles,
			pointerEvents: 'none',
		};
	}

	return commonStyles;
};

export const getStepTitleWrapperStyles = (isMobile: boolean) => {
	const commonStyles = {
		display: 'flex',
		alignItems: 'center',
		gap: '12px',
	};

	if (isMobile) {
		return {
			...commonStyles,
			marginBottom: '12px',
		};
	}

	return commonStyles;
};

const blockfill = keyframes`
  0% { background-image: linear-gradient(#D6D9DA 12px, transparent 0), linear-gradient(#D6D9DA 12px, transparent 0), linear-gradient(#D6D9DA 12px, transparent 0); }
    33% { background-image: linear-gradient(#002855 12px, transparent 0), linear-gradient(#D6D9DA 12px, transparent 0), linear-gradient(#D6D9DA 12px, transparent 0); }
    66% { background-image: linear-gradient(#002855 12px, transparent 0), linear-gradient(#002855 12px, transparent 0), linear-gradient(#D6D9DA 12px, transparent 0); }
    100% { background-image: linear-gradient(#002855 12px, transparent 0), linear-gradient(#002855 12px, transparent 0), linear-gradient(#002855 12px, transparent 0); }
`;

export const stepLoadingAnimationStyles = {
	display: 'inline-block',
	position: 'relative',
	height: '12px',
	width: '44px',
	backgroundImage:
		'linear-gradient(#D6D9DA 12px, transparent 0), linear-gradient(#D6D9DA 12px, transparent 0), linear-gradient(#D6D9DA 12px, transparent 0)',
	backgroundRepeat: 'no-repeat',
	backgroundSize: '12px auto',
	backgroundPosition: '0 0, 16px 0, 32px 0',
	animation: `${blockfill} 1s linear infinite`,
};
